<div
  class="card"
  layout-horizontal
  layout-align-items-center
  padding-medium
  [class.card-background-light]="hasIntegration"
>
  <div class="icon-box" layout-align-self-start>
    <ng-content select="[icon]"></ng-content>
  </div>

  <div layout layout-align-items-center layout-space-between layout-full-width>
    <div margin-lr-medium>
      <rt-heading>
        {{ heading }}
        @if (teamIntegrationsCount > 0) {
          <rt-badge
            [rtTooltip]="
              'app.settings.integrations.x_members_integrated'
                | translate: { name: heading, count: teamIntegrationsCount }
            "
            color="counter-default"
            [text]="teamIntegrationsCount"
            margin-left-small-x
          >
          </rt-badge>
        }
        @if (hasIntegration) {
          <rt-badge
            margin-left-small-x
            color="success"
            [text]="'app.settings.integrations.integrated' | translate"
          ></rt-badge>
        }
      </rt-heading>

      <div variant="subheading">
        <ng-content select="[description]"></ng-content>
      </div>
    </div>

    <ng-content select="[infobox]" />

    @if (!isComingSoon && isIntegrationLoaded) {
      <div>
        <rt-group variant="horizontal">
          @if (!hasIntegration) {
            <div>
              <rt-button (click)="integrate.emit()" variant="outline">
                {{ 'app.settings.integrations.integrate_now' | translate }}
              </rt-button>
            </div>
          }

          @if (hasIntegration) {
            <div>
              <rt-button
                #integrationActionsDropdownTrigger="rtOverlayOrigin"
                [loading]="isRemoving"
                (click)="toggleDropdown(!dropdownOpen)"
                rt-overlay-origin
                variant="plain"
              >
                <rt-icon name="edit"></rt-icon>
                {{ 'app.settings.integrations.manage' | translate }}
              </rt-button>
              <ng-template
                #integrationActionsDropdown="rtConnectedOverlay"
                rt-connected-overlay
                hasBackdrop
                [origin]="integrationActionsDropdownTrigger"
                [open]="dropdownOpen"
                (backdropClick)="toggleDropdown(false)"
              >
                <rt-dropdown [width]="DropdownWidth.SmallX">
                  <div class="integration__dropdown-items" (click)="toggleDropdown(false)">
                    <ng-content select="[dropdown-items]"></ng-content>
                  </div>

                  @if (hasRole) {
                    <rt-dropdown-item routerLink="/settings/roles">
                      {{ 'app.settings.integrations.manage_roles' | translate }}
                    </rt-dropdown-item>
                  }
                  @if (hasRemove) {
                    <rt-dropdown-item (click)="confirmRemove()">
                      {{ 'app.settings.integrations.disconnect' | translate }}
                    </rt-dropdown-item>
                  }
                </rt-dropdown>
              </ng-template>
            </div>
          }
        </rt-group>
      </div>
    }

    @if (isComingSoon) {
      <rt-button variant="outline" [disabled]="true">
        {{ 'app.settings.integrations.coming_soon' | translate }}
      </rt-button>
    }
  </div>
</div>
